import type React from 'react';

import { BannerWrapper } from 'src/app/shared/components/banners/layout';
import { LegacyHtml as Html } from 'src/app/shared/components/html';
import { useErrorText } from 'src/app/shared/hooks/error';

export const PetitionUnderReviewBanner: React.FC = () => {
	const text = useErrorText('petition_under_review');

	return (
		<BannerWrapper py={8}>
			<Html html={text.header} size="large" />
			<Html
				html={text.main}
				mt={16}
				sx={{
					p: {
						margin: '8px 0',
					},
					// overrides the margins sets by <Html>
					'p+p': {
						marginTop: '8px',
					},
				}}
			/>
		</BannerWrapper>
	);
};
